import { COMMON_DATA_KEY, H5_PLAY_EVENT, ErrorCode, PLAY_MODE, PLAY_EVENT, VIDEO_STATE, Plugin, H5Player } from '@tencent/thumbplayer-h5';
import { __spreadArray, __extends, __assign } from 'tslib';
import { defaultI18nConfig, uaTool, SimpleDefer, commonTool, domTool } from '@tencent/thumbplayer-core';
import { txpHideClass, isMobile } from '@tencent/thumbplayer-plugin-utils';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".txp_video_error{position:absolute;top:0;left:0;width:100%;height:100%;z-index:99;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#111;color:#fff}.txp_video_error.txp_none,.txp_video_error .txp_none{display:none!important}.txp_video_error a{color:#fff;text-decoration:none}.txp_video_error .txp_error_title{margin:10px 20px;font-size:18px;line-height:1.6;text-align:center}.txp_video_error .txp_error_title .txp_btn{color:#ff6428;font-size:inherit}.txp_video_error .error-noise-bg{position:absolute;width:100%;height:100%;left:0;top:0;z-index:-1}.txp_video_error .txp_error_code{margin:30px 20px 0;line-height:1.5;color:#666;pointer-events:auto;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.txp_video_error .txp_error_code a{cursor:pointer;color:#666;border-bottom:1px solid}.txp_video_error .txp_error_code a:hover{color:#ff6428}.txp_video_error .txp_error_code::-moz-selection, .txp_video_error .txp_error_code ::-moz-selection{color:#fff;background:#eee}.txp_video_error .txp_error_code::selection,.txp_video_error .txp_error_code ::selection{color:#fff;background:#eee}.txp_video_error .txp_error_code::-moz-selection,.txp_video_error .txp_error_code ::-moz-selection{color:#fff;background:#eee}.txp_video_error .none{display:none}.txp_video_error .txp_link_refresh{color:#fc6526}.txp_video_error .txp_link_btn{display:block;outline:none;border:none;margin-bottom:16px;padding:0 20px;border-radius:15px;background:#26262b;color:#fc6526;font-size:14px;line-height:30px;cursor:pointer}.txp_video_error .txp_link_btn:hover{color:#fff;background-color:#fc6526}.txp_video_error .txp_browser a{text-decoration:underline;cursor:pointer}.txp_video_error .txp_browser a:hover{color:#ff6428}";
styleInject(css_248z);

var queue = [];
var isReq = false;
var qqlive = 0;

var getClient = function (callback) {
    if (qqlive) {
      callback(qqlive);
      return;
    }
    queue.push(callback);
    if (!isReq) {
      isReq = true;
      if (document.domain != 'qq.com') {
        throw new Error('document.domain is not qq.com');
      }
      var $frame = document.createElement('iframe');
      $frame.src = "javascript:'<script>window.onload=function(){document.write(\\'<script>document.domain=\\\"qq.com\\\";<\\\\/script>\\');document.close();};<\/script>'";
      $frame.style.cssText = 'display:none;';
      document.body.appendChild($frame);
      $frame.getClient = function (_qqlive) {
        qqlive = _qqlive;
        var cb = queue.shift();
        while (cb) {
          cb && cb(_qqlive);
          cb = queue.shift();
        }
      };
      $frame.src = '//v.qq.com/iframe/client.html';
    }
};

/* eslint-disable @typescript-eslint/naming-convention */
var ErrorPagePluginName = 'error-page';
var ErrorPagePluginEvents = { REPORT_LOG: 'error-page:report-log' };
/** 默认错误文案 */
var defaultErrorText = '出错啦';
var defaultErrorMsg = '这个视频被外星人劫走，暂时看不了了~';
var dataRoleMap = {
    error: 'txp-ui-error',
    errorMsg: 'txp-ui-error-msg',
    errorHandler: 'txp-ui-error-handler',
    errorRefresh: 'txp-ui-error-refresh',
    errorCode: 'txp-ui-error-code',
    background: 'txp-ui-error-background',
    clientBtn: 'txp-ui-error-client-btn',
    browserTip: 'txp-ui-error-browser',
};

var DRM_MODULE_ERROR_CODE_REGEX = /^7009\d+(\.?-?\d+)?$/;
/**
 * 直播加密相关错误码
 */
var ENV_NOT_SUPPORT_ENCRYPTION_LIVE_CODES = [
    '70023097',
    '70023098',
];
/**
 * 点播加密相关错误码
 */
var ENV_NOT_SUPPORT_ENCRYPTION_VOD_CODES = [
    '70013069.4',
    '70013097.0',
    '70013097.2',
    '70013098.1',
    '70013080.14',
];
/**
 * 没有版权错误码
 */
var NO_PLAYBACK_COPYRIGHTS_CODE = '70013080.2';
/**
 * 根据错误码增加引导语
 */
function getGuidingMessage(code) {
    var guidingCodes = __spreadArray(__spreadArray([], ENV_NOT_SUPPORT_ENCRYPTION_LIVE_CODES, true), ENV_NOT_SUPPORT_ENCRYPTION_VOD_CODES, true);
    if (guidingCodes.indexOf(code) !== -1
        || DRM_MODULE_ERROR_CODE_REGEX.test(code)) {
        return '<p>为保护正版防止盗版，您可以尝试</p>';
    }
    return '<p>您可以尝试</p>';
}
/**
 * 是否需要显示拉动客户端
 */
function checkIfClientNeeded(code, isLive) {
    if (isLive === void 0) { isLive = false; }
    // 如果是DRM模块抛出的，这里我们也需要识别为需要拉起客户端
    if (DRM_MODULE_ERROR_CODE_REGEX.test(code))
        return true;
    if (isLive) {
        return ENV_NOT_SUPPORT_ENCRYPTION_LIVE_CODES.indexOf(code) !== -1;
    }
    return __spreadArray(__spreadArray([], ENV_NOT_SUPPORT_ENCRYPTION_VOD_CODES, true), [NO_PLAYBACK_COPYRIGHTS_CODE], false).indexOf(code) !== -1;
}
// override DRM error code
Object.keys(defaultI18nConfig.core).forEach(function (key) {
    if (/ERROR_DRM_.*/.test(key)) {
        defaultI18nConfig.core[key] = '该视频因版权方安全保密级别较高，当前浏览器不支持加密播放';
    }
});

var errorPageI18nConfig = {
    /** 刷新按钮左侧文案 */
    REFRESH_BTN_TEXT_LEFT: '你可以',
    /** 刷新按钮文案 */
    REFRESH_BTN_TEXT: '刷新',
    /** 刷新按钮右侧文案 */
    REFRESH_BTN_TEXT_RIGHT: '试试',
};
defaultI18nConfig.errorPagePlugin = errorPageI18nConfig;

function saveChannel(tag) {
    var channelText = "qqlivechannel=channel1." + tag;
    if (uaTool.browser.ie) {
        var curTime = new Date();
        curTime.setTime(curTime.getTime() + 24 * 60 * 60 * 1000);
        document.cookie = channelText + ";path=/;expires=" + curTime.toUTCString();
    }
    else {
        var input = document.createElement('input');
        document.querySelector('body').append(input);
        input.style.position = 'absolute';
        input.style.top = '-9999px';
        input.value = channelText;
        input.style.top = document.querySelector('body').scrollTop + "px";
        input.focus();
        input.setSelectionRange(0, channelText.length);
        if (document.queryCommandSupported('copy')) {
            document.execCommand('copy', true);
        }
        input.remove();
    }
}
function openClient(data) {
    if (data.support && data.sso) {
        try {
            saveChannel(data.atag);
        }
        catch (e) { }
        try {
            getClient(function (client) {
                if (client) {
                    client.exist()
                        .done(function () {
                        client.open(data.sso);
                        data.success();
                    })
                        .fail(function () {
                        data.error();
                    });
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }
}

var qqbrowserHelper = {
    exist: false,
    /**
       * 判断windows/os x版本下的最新版chrome是否支持drm，以下这几个版本的 chrome，最大版本号到chrome 50，而 chrome drm 模块是在63才引入
       * 所以对于这些操作系统，无论怎么升级浏览器都是徒劳的，只需要引导用pc客户端播放就行
       * https://support.google.com/chrome/a/answer/7100626?hl=en
       */
    isLatestChromeSupportDrm: function () {
        var os = uaTool.os;
        var ver;
        if (os.windows) {
            ver = parseFloat(os.version);
            return ver > 6.0;
        }
        if (os.mac) {
            if (uaTool.browser.qqbrowser)
                return false;
            var verList = (os.version || '').split('.');
            ver = parseFloat(((verList[0] || '0') + "." + (verList[1] || '0')));
            return ver > 10.10;
        }
        if (os.linux) { // linux上暂不支持
            return false;
        }
    },
    detect: function () {
        var minVersion = '10.2.2101.400'; // qq浏览器最低支持drm的版本号 10.2.2101.400
        var defer = new SimpleDefer();
        var meta = document.createElement('meta');
        meta.name = 'referrer';
        meta.content = 'always';
        document.head.prepend(meta);
        var isLatestChromeSupportDrm = this.isLatestChromeSupportDrm();
        if (!isLatestChromeSupportDrm) {
            defer.reject();
        }
        else {
            fetch('http://127.0.0.1:28653/api/handle', {
                method: 'POST',
                body: JSON.stringify({
                    action: 'GetQBVersion',
                    cmd: '',
                }),
            }).then(function (res) { return res.json(); })
                .then(function (res) {
                meta.remove();
                var isOk = false;
                var result = res.result || '';
                if (result) {
                    isOk = commonTool.compareVersion(result, minVersion) !== -1;
                }
                if (isOk) {
                    qqbrowserHelper.exist = true;
                    defer.resolve({ exist: true });
                }
                else {
                    qqbrowserHelper.exist = false;
                    defer.resolve({ exist: false });
                }
            })
                .catch(function () {
                meta.remove();
                qqbrowserHelper.exist = false;
                defer.resolve({ exist: false });
            });
        }
        return defer;
    },
    download: function () {
        try {
            location.assign('https://dldir1.qq.com/invc/tt/QQBrowser_Setup_DRM.exe');
        }
        catch (e) { }
    },
    open: function (url) {
        if (!qqbrowserHelper.exist) {
            this.download();
        }
        else {
            // 由https的站点发起http请求时，默认不会带referrer，因此需要加上这个meta标签
            // https://imququ.com/post/referrer-policy.html
            var meta_1 = document.createElement('meta');
            meta_1.name = 'referrer';
            meta_1.content = 'always';
            document.head.prepend(meta_1);
            fetch('http://127.0.0.1:28653/api/handle', {
                method: 'POST',
                body: JSON.stringify({
                    action: 'Open',
                    cmd: encodeURIComponent(url),
                }),
            }).then(function () {
                meta_1.remove();
            })
                .catch(function () {
                meta_1.remove();
            });
        }
    },
};

var defaultNoiseConfig = {
    enable: !isMobile,
    interval: 150,
    performanceRatio: 5,
    size: 4,
    opacity: 0.05,
};
var WHITE_RGB_VALUE = (255 << 16) + (255 << 8) + 255;
/** 错误页插件
 *
 * 从上往下4个节点，图片-文案-刷新提示-错误码/flowid
 *
 * 双击错误码/flowid上报，单次错误只能上报一次
 */
var ErrorPagePlugin = /** @class */ (function (_super) {
    __extends(ErrorPagePlugin, _super);
    function ErrorPagePlugin(player, config, extra) {
        var _a;
        var _this = _super.call(this, player, config, extra) || this;
        /** 内部dom引用 */
        _this.innerElements = {};
        _this.clientExistDefer = new SimpleDefer();
        /**
         * 白色噪点特效动画 canvas 绘制实现
         * @param canvasCtx - Canvas Context
         * @param width - Canvas 元素的的宽度 HTMLCanvasElement.prototype.width
         * @param height - Canvas 元素的的宽度 HTMLCanvasElement.prototype.height
         * @param opacity - 噪点透明度
         * @param performanceRatio - 性能节流比例，如果画布尺寸很大情况下，需要绘制的像素点会非常多，这里就需要做性能节流
         */
        _this.noiseAnimation = function (canvasCtx, width, height, opacity, performanceRatio) {
            var pHeight = Math.floor(height / performanceRatio);
            var imageData = canvasCtx.createImageData(width, pHeight);
            var buffer = new Uint32Array(imageData.data.buffer);
            // 1. 每次循环，清理上次画布，形成动画
            canvasCtx.clearRect(0, 0, width, height);
            // 2. 绘制噪点，但仅绘制一部分画布，剩下部分循环使用这部分数据进行填充
            for (var i = 0; i < buffer.length; i++) {
                // imageData 中为 RGBA 数据，每个通道 8 位，这里用 UInit32 一次性操作
                // 不过这里要注意，这 32 位数据分别是 Alpha / Blue / Green / Red
                // 所以生成的是白色的随机噪点
                buffer[i] = ((255 * Math.random() * opacity | 0) << 24) + WHITE_RGB_VALUE;
            }
            // 3. 填充剩余数据
            for (var i = 0; i <= performanceRatio; i++) {
                canvasCtx.putImageData(imageData, 0, pHeight * i);
            }
        };
        /**
         * 浏览器提示文字的点击事件
         */
        _this.browserTipClick = function () {
            // 拉起QQ浏览器/下载QQ浏览器
            qqbrowserHelper.open(location.href);
        };
        _this.config = __assign(__assign({}, player.config.errorPageConfig), config);
        _this.config.noiseConfig = __assign(__assign({}, defaultNoiseConfig), (_a = _this.config) === null || _a === void 0 ? void 0 : _a.noiseConfig);
        _this.insertDOM();
        _this.setupDOMEvents();
        _this.setupPlayerEvents();
        return _this;
    }
    /** 展示/更新错误页 */
    ErrorPagePlugin.prototype.show = function (param) {
        if (param === void 0) { param = defaultErrorText; }
        var flowid = this.player.getCommonKv(COMMON_DATA_KEY.flowid) || '';
        var hasImg = typeof param === 'object' && Boolean(param === null || param === void 0 ? void 0 : param.img);
        if (typeof param === 'string') {
            this.innerElements.errorMsg.innerHTML = param;
            this.innerElements.errorCode.innerHTML = flowid;
            // 只传入msg时重置参数,隐藏图片、展示刷新按钮
            this.innerElements.background.classList.add(txpHideClass);
            this.innerElements.errorRefresh.classList.remove(txpHideClass);
        }
        else {
            var _a = param.text, text = _a === void 0 ? defaultErrorText : _a, _b = param.code, code = _b === void 0 ? '' : _b, _c = param.img, img = _c === void 0 ? '' : _c, _d = param.hideRefresh, hideRefresh = _d === void 0 ? false : _d;
            this.innerElements.errorMsg.innerHTML = text;
            this.innerElements.errorCode.innerHTML = code ? String(code) + "-" + flowid : flowid;
            this.innerElements.background.src = img;
            this.innerElements.background.classList.toggle(txpHideClass, !img);
            this.innerElements.errorRefresh.classList.toggle(txpHideClass, hideRefresh);
        }
        this.rootEl.classList.remove(txpHideClass);
        this.setNoise(!hasImg);
    };
    /** 隐藏错误页 */
    ErrorPagePlugin.prototype.hide = function () {
        this.rootEl.classList.add(txpHideClass);
        this.setNoise(false);
        domTool.addClass(this.innerElements.clientBtn, txpHideClass);
        domTool.addClass(this.innerElements.browserTip, txpHideClass);
        domTool.addClass(this.innerElements.errorRefresh, txpHideClass);
    };
    /** 销毁插件，移除dom */
    ErrorPagePlugin.prototype.destroy = function () {
        var _a;
        this.setNoise(false);
        if (this.rootEl.parentNode)
            this.rootEl.remove();
        this.innerElements = {};
        (_a = this.noiseBg) === null || _a === void 0 ? void 0 : _a.remove();
        this.noiseBg = null;
        this.rootEl = null;
        _super.prototype.destroy.call(this);
    };
    ErrorPagePlugin.prototype.insertDOM = function () {
        var _this = this;
        var container = this.player.container;
        var noiseConfig = this.config.noiseConfig;
        var REFRESH_BTN_TEXT_LEFT = errorPageI18nConfig.REFRESH_BTN_TEXT_LEFT, REFRESH_BTN_TEXT = errorPageI18nConfig.REFRESH_BTN_TEXT, REFRESH_BTN_TEXT_RIGHT = errorPageI18nConfig.REFRESH_BTN_TEXT_RIGHT;
        var htmlStr = "<div data-role=\"" + dataRoleMap.error + "\" class=\"txp_video_error " + txpHideClass + "\">\n      " + (noiseConfig.enable ? '<canvas class="error-noise-bg"></canvas>' : '') + "\n      <img data-role=\"" + dataRoleMap.background + "\" alt=\"error-background\"/>\n      <div data-role=\"" + dataRoleMap.errorMsg + "\" class=\"txp_error_title\"></div>\n      <div data-role=\"" + dataRoleMap.errorHandler + "\" class=\"txp_error_desc\">\n        <span data-role=\"" + dataRoleMap.errorRefresh + "\">\n          " + REFRESH_BTN_TEXT_LEFT + " <a href=\"javascript:;\" class=\"txp_link_refresh\">" + REFRESH_BTN_TEXT + "</a> " + REFRESH_BTN_TEXT_RIGHT + "\n        </span>\n      </div>\n      <button data-role=\"" + dataRoleMap.clientBtn + "\" class=\"txp_link_btn " + txpHideClass + "\"></button>\n      <div data-role=\"" + dataRoleMap.browserTip + "\" class=\"txp_browser " + txpHideClass + "\"></div>\n      <div class=\"txp_error_code\" data-role=\"" + dataRoleMap.errorCode + "\"></div>\n    </div>";
        container.insertAdjacentHTML('beforeend', htmlStr);
        this.rootEl = container.querySelector("[data-role=\"" + dataRoleMap.error + "\"]");
        this.noiseBg = this.rootEl.querySelector('canvas');
        Object.keys(dataRoleMap).forEach(function (key) {
            _this.innerElements[key] = container.querySelector("[data-role=\"" + dataRoleMap[key] + "\"]");
        });
    };
    ErrorPagePlugin.prototype.setupDOMEvents = function () {
        var _this = this;
        // 点击刷新按钮
        this.innerElements.errorRefresh.querySelector('.txp_link_refresh').addEventListener('click', function () {
            if (_this.config.useReplay) {
                _this.player.replay();
            }
            else {
                location.reload();
            }
        });
        // 连续点击5次错误码上报日志
        var clickMaxTime = 5;
        var clickDelay = 300;
        var clickCount = 0;
        var clickTimer = 0;
        this.innerElements.errorCode.addEventListener('click', function () {
            clickCount += 1;
            if (clickCount >= clickMaxTime) {
                clickCount = 0;
                _this.emit(ErrorPagePlugin.Events.REPORT_LOG);
            }
            if (clickTimer)
                clearTimeout(clickTimer);
            clickTimer = window.setTimeout(function () { return clickCount = 0; }, clickDelay);
        });
        // 客户端按钮点击事件
        this.innerElements.clientBtn.addEventListener('click', function () {
            _this.clientExistDefer.promise.then(function (client) {
                // 检测到存在客户端
                _this.clickClientBtnOnExist(client);
            }).catch(function () {
                // 检测到不存在
                _this.clickClientBtnOnNoExist();
            });
        });
    };
    ErrorPagePlugin.prototype.setupPlayerEvents = function () {
        var _this = this;
        var player = this.player;
        // 监听error自动展示
        player.on(H5_PLAY_EVENT.PLAY_SESSION_END, function (_a) {
            var data = _a.data;
            if (!_this.config.showOnError) {
                return;
            }
            var code = data.code, errorData = data.data;
            if (code === ErrorCode.SUC || !!(errorData === null || errorData === void 0 ? void 0 : errorData.noErrorPage))
                return;
            var img = _this.config.img;
            var hideRefreshFromUser = _this.config.hideRefresh;
            var isLive = player.config.type === PLAY_MODE.LIVE;
            var isClientNeeded = checkIfClientNeeded(code, isLive);
            if (isLive && data.data) { // 直播
                var liveErrorDataName = data.data.name;
                if (liveErrorDataName !== 'setErrorView') {
                    // 直播某些错误码并不需要设置错误界面，例如回看时getinfo返回鉴权失败，那么我们只需要给引用方派发错误事件即可，并不需要展示错误界面
                    return;
                }
                // 直播错误信息可能返回msg、hideCode、hideRefresh，过滤部分按钮和错误码文案
                var _b = data.data.params, hideRefresh = _b.hideRefresh, hideCode = _b.hideCode;
                if (hideRefresh) {
                    // 无需展示刷新（出错了刷新也没用）
                    domTool.addClass(_this.innerElements.errorRefresh, txpHideClass);
                }
                else {
                    domTool.removeClass(_this.innerElements.errorRefresh, txpHideClass);
                }
                hideRefreshFromUser = hideRefresh;
                if (hideCode) {
                    domTool.addClass(_this.innerElements.errorCode, txpHideClass);
                }
                else {
                    domTool.removeClass(_this.innerElements.errorCode, txpHideClass);
                }
            }
            // 检查是否需要拉起客户端或提示浏览器版本
            if (isClientNeeded) {
                if (_this.config.useClientBtn) {
                    _this.checkClientExist();
                    _this.setClientBtn();
                    hideRefreshFromUser = true;
                }
                if (_this.config.useBrowserTip) {
                    _this.setBrowserTip();
                    hideRefreshFromUser = true;
                }
            }
            var message = _this.getErrMsg(data, isLive, isClientNeeded);
            _this.show({ code: code, text: message, hideRefresh: hideRefreshFromUser, img: img });
        });
        // 监听播放正常/播放开始时隐藏
        player.on(PLAY_EVENT.STATE_CHANGE, function (_a) {
            var data = _a.data;
            var newState = data.new;
            if (newState === VIDEO_STATE.PLAYING || newState === VIDEO_STATE.CANPLAY)
                _this.hide();
        });
        player.on(H5_PLAY_EVENT.PLAY_SESSION_START, function () { return _this.hide(); });
    };
    ErrorPagePlugin.prototype.getErrMsg = function (data, isLive, isClientNeeded) {
        var code = data.code;
        var _a = this.config, fuzzy = _a.fuzzy, _b = _a.dictionary, dictionary = _b === void 0 ? {} : _b;
        var fuzzyCode = fuzzy ? code.split('.')[0] : null;
        var messageConfigured = dictionary[code] || dictionary[fuzzyCode];
        if (messageConfigured) {
            return messageConfigured;
        }
        var isNeedGuidingMsg = isClientNeeded && (this.config.useClientBtn || this.config.useBrowserTip);
        var msg = isLive ? this.getLiveErrMsg(data, isNeedGuidingMsg) : this.getVodErrMsg(data, isNeedGuidingMsg);
        // defaultErrorMsg这个是怕版本不兼容情况，例如旧播放器没有给后台返回的文案，这里可能为空
        return msg || defaultErrorMsg;
    };
    /**
     *  直播的错误文案
     */
    ErrorPagePlugin.prototype.getLiveErrMsg = function (data, isNeedGuidingMessage) {
        var message = data.message;
        if (!data.data) {
            return message;
        }
        var msg = data.data.params.msg;
        var code = data.code;
        if (msg) {
            // 直播的错误信息中可能没有msg属性，只有付费拉动的信息
            message = msg;
        }
        // 拼接需要的引导词
        if (isNeedGuidingMessage) {
            // 只有当需要引导语时，才将core的错误码映射到业务错误文案上
            // todo 这里是借用了一部分逻辑 后续需要用一个统一的开关去处理
            message = "" + message + getGuidingMessage(code);
        }
        return message;
    };
    /**
     * 点播 getinfo 错误码对应文案转换
     */
    ErrorPagePlugin.prototype.getVodErrMsg = function (data, isNeedGuidingMessage) {
        var message = data.message;
        var code = data.code;
        if (!(code.startsWith(ErrorCode.GETINFO_SERVER_CODE_PREFIX) // 后台
            || code.startsWith('7009') // drm模块
        )) {
            // 只处理是后台返回的错误码
            return message;
        }
        // 拼接需要的引导词
        if (isNeedGuidingMessage) {
            // 只有当需要引导语时，才将core的错误码映射到业务错误文案上
            // todo 这里是借用了一部分逻辑 后续需要用一个统一的开关去处理
            message = "" + message + getGuidingMessage(code);
        }
        return message;
    };
    /**
     * 设置客户端按钮文案，并显示
     */
    ErrorPagePlugin.prototype.setClientBtn = function () {
        var _this = this;
        // 隐藏刷新文案
        var clientBtnText = uaTool.os.mac ? 'Mac客户端观看' : 'PC客户端观看';
        if (uaTool.os.mac) {
            // mac检测拉起不太准，所以mac客户端就全部显示打开
            this.innerElements.clientBtn.innerHTML = "\u6253\u5F00" + clientBtnText;
        }
        else {
            this.clientExistDefer.promise.then(function () {
                _this.innerElements.clientBtn.innerHTML = "\u6253\u5F00" + clientBtnText;
            }).catch(function () {
                _this.innerElements.clientBtn.innerHTML = "\u4E0B\u8F7D" + clientBtnText;
            });
        }
        // 显示客户端按钮
        domTool.removeClass(this.innerElements.clientBtn, txpHideClass);
    };
    /**
     * 设置噪点特效展示状态
     * @param isShow 是否展示噪点特效，设置为 false 则停止
     */
    ErrorPagePlugin.prototype.setNoise = function (isShow) {
        var _this = this;
        if (isShow === void 0) { isShow = true; }
        var noiseConfig = this.config.noiseConfig;
        var enable = noiseConfig.enable, performanceRatio = noiseConfig.performanceRatio, opacity = noiseConfig.opacity;
        // 如果没有开启噪点特效，则什么也不做
        if (!enable || !this.noiseBg)
            return;
        clearInterval(this.noiseTimer);
        domTool.css(this.noiseBg, 'display', isShow ? 'block' : 'none');
        // 如果设置特效打开，则开始展示特效
        if (isShow) {
            var ctx_1 = this.noiseBg.getContext('2d');
            // 渲染前，调整背景大小覆盖播放器容器
            this.resizeNoise();
            var _a = this.noiseBg, width_1 = _a.width, height_1 = _a.height;
            // 如果拿到的 canvas 高或宽为 0，则没必要渲染（如播放器容器本身 display: none）
            if (!width_1 || !height_1) {
                return;
            }
            // 先立即渲染一次，防止视觉上有延迟
            this.noiseAnimation(ctx_1, width_1, height_1, opacity, performanceRatio);
            // 循环渲染形成动画
            this.noiseTimer = setInterval(function () {
                _this.noiseAnimation(ctx_1, width_1, height_1, opacity, performanceRatio);
            }, noiseConfig.interval);
        }
    };
    /**
     * 根据播放器容器尺寸，等比例设置噪点 canvas 尺寸
     */
    ErrorPagePlugin.prototype.resizeNoise = function () {
        if (!this.noiseBg)
            return;
        var _a = this.player.container, clientWidth = _a.clientWidth, clientHeight = _a.clientHeight;
        var noiseSize = this.config.noiseConfig.size;
        // 这里设置宽高不等于播放器宽高，是因为后面会用 CSS 拉伸 canvas，从而达到增大噪点的效果
        this.noiseBg.width = clientWidth / noiseSize;
        this.noiseBg.height = clientHeight / noiseSize;
    };
    /**
     * 检测客户端是否存在
     */
    ErrorPagePlugin.prototype.checkClientExist = function () {
        var _this = this;
        try {
            getClient(function (client) {
                if (client) {
                    var res = client.exist();
                    res.done(function () {
                        _this.clientExistDefer.resolve(client);
                    }).fail(function () {
                        _this.clientExistDefer.reject();
                    });
                }
                else {
                    _this.clientExistDefer.reject();
                }
            });
        }
        catch (error) {
            this.clientExistDefer.reject();
        }
    };
    /**
     * 当客户端存在时，点击按钮的行为
     */
    ErrorPagePlugin.prototype.clickClientBtnOnExist = function (client) {
        // 区分直播和点播
        if (this.player.config.type === PLAY_MODE.LIVE) {
            var livepid = this.player.getCommonKv(COMMON_DATA_KEY.livepid) || '';
            var cnlid = this.player.vid || '';
            var sso = "qqlive://sso/pid=" + livepid + "&projectid=" + cnlid;
            client.open(sso);
        }
        else {
            var vid = this.player.vid;
            var cid = this.player.getCommonKv(COMMON_DATA_KEY.cid) || '';
            var start = Math.max(this.player.playtime - 5, 0);
            var atag = 'web.playererror';
            openClient({
                support: true,
                atag: 'playererror',
                sso: "qqlive://sso/vbarid=" + cid + "&videoid=" + vid + "&start=" + start + "&atag=" + atag,
                success: function () {
                    // 成功拉起客户端了
                    // TODO: 是否需要上报？
                },
                error: function () {
                    this.openDownLoadLink();
                },
            });
        }
    };
    /**
     * 当客户端不存在时的点击行为
     */
    ErrorPagePlugin.prototype.clickClientBtnOnNoExist = function () {
        this.openDownLoadLink();
    };
    /**
     * 打开腾讯视频客户端下载链接
     */
    ErrorPagePlugin.prototype.openDownLoadLink = function () {
        window.open("https://v.qq.com/download.html#" + (uaTool.os.mac ? 'Mac' : 'Windows'), '_blank');
    };
    /**
     * 设置浏览器提示文案
     */
    ErrorPagePlugin.prototype.setBrowserTip = function () {
        this.innerElements.browserTip.removeEventListener('click', this.browserTipClick);
        // 显示浏览器提示
        domTool.removeClass(this.innerElements.browserTip, txpHideClass);
        // qq浏览目前不支持widevine L3的最低版本要求，暂时屏蔽
        /**
         * qqbrowserHelper.detect().promise.then((qqbrowser: any) => {
        //       exist = qqbrowser.exist;
        //       this.innerElements.browserTip.innerHTML = `或${exist ? '使用' : '下载'}最新
        // <a style="display:inline; margin: 16px 0 0 0;text-decoration: underline;">QQ 浏览器</a>、Chrome 浏览器观看`;
        //       // 监听浏览器提示点击事件
        //       this.innerElements.browserTip.addEventListener('click', this.browserTipClick);
        //     }).catch(() => {
        //       domTool.addClass(this.innerElements.browserTip, hideClass);
        //     });
         */
        if (uaTool.os.mac) {
            this.innerElements.browserTip.innerHTML = '或下载最新 Chrome、Safari 浏览器观看';
        }
        else {
            this.innerElements.browserTip.innerHTML = '或下载最新 Chrome、Edge 浏览器观看';
        }
    };
    /** 实例上广播的事件名 */
    ErrorPagePlugin.Events = ErrorPagePluginEvents;
    ErrorPagePlugin.pluginName = ErrorPagePluginName;
    return ErrorPagePlugin;
}(Plugin));

H5Player.registerPlugin(ErrorPagePlugin.pluginName, ErrorPagePlugin);

export { ErrorPagePlugin };
